export default __webpack_public_path__ + "static/media/generali.12f9839a.png";